import { create } from "zustand";
import React from "react";
import { ModalWithIcon } from "./RfModal/ModalWithIcon";

const modalStore = create((set) => ({
    modal: { isOpen: false, title: "", message: "" },
    openModal: (title, message) =>
        set((state) => ({ modal: { ...state.modal, isOpen: true, title, message } })),
    closeModal: () =>
        set((state) => ({ modal: { ...state.modal, isOpen: false, title: "", message: "" } }))
}));

export function ErrorModal() {
    const { modal, closeModal } = modalStore((state) => state);

    if (!modal.isOpen) return null;

    return (
        <ModalWithIcon
            isOpen={modal.isOpen}
            onClose={closeModal}
            type="danger"
            icon="far fa-exclamation-circle"
            title={modal.title}
            submitButtonText="Close"
            onSubmit={closeModal}
            submitButtonProps={{ type: "secondary" }}
        >
            {modal.message}
        </ModalWithIcon>
    );
}

export default ErrorModal;

export function showErrorModal(obj, props) {
    let title = "Error";
    let message = "An error occurred";
    if (obj instanceof Error) {
        //TODO: further customize modal display based on error info
        const error = obj;
        // readyState --> https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState
        if (error?.http?.readyState === 0) {
            title = props?.title || "Can't connect";
            message = props?.message || "Please check your internet connection.";
        } else if (error?.http?.readyState === 4 && error?.http?.status == 500) {
            title = props?.title || "Unknown server error";
            message =
                props?.message ||
                "Sorry, an unknown server error occurred. Our engineering team has been notified.";
        } else {
            console.error("error obj", error);
            title = props?.title || title;
            message = props?.message || error.message || message;
        }
    } else {
        if (obj.responseJSON?.error) {
            title = obj.statusText || title;
            message = obj.responseJSON.error?.message || obj.responseJSON.error || message;
        } else {
            title = obj.title || title;
            message = obj.message || message;
        }
    }
    modalStore.setState({ modal: { isOpen: true, title, message } });
}

export function withErrorModal(fn) {
    return async (...args) => {
        try {
            return await fn(...args);
        } catch (error) {
            showErrorModal(error);
            throw error; // Re-throw to allow callers to handle the error state
        }
    };
}
